// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2nHdy","rightAdornment":"Header_rightAdornment__eZBXe"};